(function () {
	'use strict';
	angular.module('app.dashboard')
		.controller('metricCommentSlideIn', metricCommentSlideIn);

	metricCommentSlideIn.$inject = ['$scope', '$compile', '$timeout', '$sce', '$filter', 'row',
		'commentsService', 'leanTableService', 'slideInModalService', 'userAttributes', 'metricsService'];
	function metricCommentSlideIn($scope, $compile, $timeout, $sce, $filter, row,
			commentsService, leanTableService, slideInModalService, userAttributes, metricsService) {
		var vm = this;
		// Comment History functions
		var timeoutMap = {};
		var visibleMap = {};
		var promiseMap = {};
		var tooltipVisibleMap = {};
		var HASH_PREFIX = 'msi';
		var DEFAULT_SORT_COLUMN = 'dateSort';
		var DEFAULT_SORT_DIR = 'ASC';

		vm.row = row;
		setDefaultSort(row.crossSiteName);
		vm.tooltips = {};
		vm.showTooltip = false;
		vm.showIt = showIt;
		vm.hideIt = hideIt;
		vm.getTooltip = getTooltip;
		vm.tooltipIsReady = tooltipIsReady;
		vm.closeDialog = closeDialog;
		vm.saveEdit = saveEdit;
		vm.cancelEdit = cancelEdit;
		vm.showEdit = showEdit;
		vm.allowComments = true;
		vm.setSort = setSort;
		vm.sortFunction = sortFunction;
		vm.selectTab = selectTab;
		vm.activeTab = 'data';
		vm.showValueStreams = false;
		var dateArray = row.period.split('-');
		var year = dateArray.len == 2 ? dateArray[1] : $filter('date')(new Date(), 'yyyy', 'UTC');
		for (var i = 0; i < vm.row.metricResults.length; i++) {
			if (typeof vm.row.metricResults[i].date !== 'undefined') {
				vm.row.metricResults[i].actualDate = vm.row.metricResults[i].date;
				vm.row.metricResults[i].dateSort = moment((vm.row.metricResults[i].date + ' ' + year).replace(' ', '/')).toDate();
			}
			if (isNaN(parseInt(vm.row.metricResults[i].metricResultNdx))) {
				vm.allowComments = false;
			}
		}

		function closeDialog() {
			slideInModalService.closeModal();
		}

		function showEdit(metricResultNdx) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#metricComment' + metricResultNdx);
			var pos = cell.offset();
			if (window.scrollY) {
				pos.top -= window.scrollY;
			}
			if (window.scrollX) {
				pos.left -= window.scrollX;
			}
			vm.currentRow = getRowFromMetricResultNdx(metricResultNdx);
			vm.currentComment = vm.currentRow.comment;
			var editTemplate = getTemplate(pos, metricResultNdx);
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('.embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				if (code == 13) {
					vm.saveEdit(metricResultNdx);
				} else if (code == 27) {
					vm.cancelEdit();
				}
			});
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		}

		function saveEdit(metricResultNdx) {
			var cell = jQuery('#metricComment' + metricResultNdx);
			var row = getRowFromMetricResultNdx(metricResultNdx);
			var currentContent = row.comment;
			var value = {};
			value.comment = strip(vm.currentComment);
			if (row.commentNdx || row.commentNdx === 0) value.ndx = row.commentNdx;
			if (value.ndx || value.ndx == 0 || value.comment) {
				//Save comment
				var htmlText = '';
				addLoadingSpinnerOnSave(cell);
				value.leanDirFactoryNdx = row.leanDirFactoryNdx;
				value.metricResultNdx = metricResultNdx;
				value.subType = 'status';
				if (currentContent === value.comment) {
					removeLoadingSpinnerOnFinish(cell);
					cell.children('.cell-div').html(currentContent);
					return;
				}
				commentsService.saveComment(row.leanDirFactoryNdx, 'metric', value)
					.then(function (data) {
						removeLoadingSpinnerOnFinish(cell);
						if (data && data.ndx) {
							if (data && data.error) {
								$scope.addErrorToast(data.error);
								cell.children('.cell-div').html(currentContent);
							} else {
								row.commentNdx = data.ndx;
								row.comment = value.comment;
								htmlText = value.comment;
								cell.children('.cell-div').html(htmlText);
							}
						}
					});
				vm.currentRow.comment = vm.currentComment;
			}
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			$scope.inlineActive = false;
		}

		function cancelEdit() {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.currentRow = undefined;
			vm.currentComment = undefined;
			vm.inlineActive = false;
		}

		function getTemplate(position, metricResultNdx) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + 296 > windowWidth) {
				position.left = position.left - (position.left + 296 - windowWidth - 8);
			}
			if (position.top + 112 > windowHeight) {
				position.top = position.top - (position.top + 112 - windowHeight - 8);
			}
			var editTemplate = '<div class="inlineEditDiv textEdit" style="top:' + position.top + 'px; left: ' +
				position.left + 'px;" ng-style="{\'z-index\': 1056 + $$topModalIndex*10}"><div class="inlineEditHeader">Add a comment</div>' +
				'<div class="input-holder-with-clear">' +
				'<input class="inlineEditInput with-clear" ng-model="metricCommentSlideInCtrl.currentComment" />' +
				'<span class="input-clear" ng-show="metricCommentSlideInCtrl.currentComment && metricCommentSlideInCtrl.currentComment.length"' +
				' ng-click="metricCommentSlideInCtrl.currentComment = \'\'"><i class="fa fa-times"></i></span>' +
				'</div>' +
				'<div class="inlineEditButtons"><a class="button flat" ng-click="metricCommentSlideInCtrl.cancelEdit()">Cancel</a>' +
				'<a class="button flat colored" ng-click="metricCommentSlideInCtrl.saveEdit(' + metricResultNdx + ')">Save</a></div></div>';
			return editTemplate;
		}

		function addLoadingSpinnerOnSave(cell) {
			cell.children('.cell-div').html('');
			cell.css('padding-left', '8px');
			cell.children('.inlineEditIcon').css('display', 'none');
			cell.children('.cell-div').removeClass('cell-div').addClass('individual-spinner');
		}

		function removeLoadingSpinnerOnFinish(cell) {
			cell.children('.individual-spinner').removeClass('individual-spinner').addClass('cell-div');
			cell.css('padding-left', '0px');
			cell.children('.inlineEditIcon').css('display', '');
		}

		function showIt(metricResultNdx) {
			var currentTooltips = angular.element('.tooltip');
			for (var i = 0; i < currentTooltips.length; i++) {
				var tooltip = angular.element(currentTooltips[i]);
				if (tooltip && tooltip.scope()) {
					tooltip.scope().tt_isOpen = false;
				}
				jQuery('.tooltip').remove();
			}
			if (!timeoutMap[metricResultNdx]) {
				timeoutMap[metricResultNdx] = {};
			}
			if (!visibleMap[metricResultNdx]) {
				visibleMap[metricResultNdx] = {};
			}
			if (!vm.tooltips[metricResultNdx]) {
				vm.tooltips[metricResultNdx] = {};
			}
			visibleMap[metricResultNdx].status = true;
			timeoutMap[metricResultNdx].status = $timeout(function () {
				var metricResultObj = getRowFromMetricResultNdx(metricResultNdx);
				var ndx = metricResultObj.commentNdx;
				if (ndx || ndx === 0) {
					if (visibleMap[metricResultNdx].status) {
						vm.tooltips[metricResultNdx].status = getLoadingHtml('Comment');
						vm.showTooltip = true;
						tooltipVisibleMap[metricResultNdx] = true;
						if (!promiseMap[metricResultNdx]) {
							promiseMap[metricResultNdx] = {};
						}
						promiseMap[metricResultNdx].status = leanTableService.getCommentHistory(ndx, 'userComment', metricResultObj.leanDirFactoryNdx);
						promiseMap[metricResultNdx].status.promise.then(function (response) {
							if (response && response.status && response.status >= 200 && response.status < 400) {
								$timeout(function () {
									if (vm.showTooltip && visibleMap[metricResultNdx].status) {
										vm.tooltips[metricResultNdx].status = getCommentTooltipHtml(response.data);
									}
								});
							} else {
								$timeout(function () {
									vm.showTooltip = false;
									tooltipVisibleMap[metricResultNdx] = false;
									visibleMap[metricResultNdx].status = false;
									vm.tooltips[metricResultNdx].status = '';
								});
							}
						});
					}
				}
			}, 1000);
		}

		function hideIt(metricResultNdx) {
			vm.showTooltip = false;
			tooltipVisibleMap[metricResultNdx] = false;
			visibleMap[metricResultNdx].status = false;
			vm.tooltips[metricResultNdx].status = '';
			$timeout.cancel(timeoutMap[metricResultNdx].status);
			if (promiseMap[metricResultNdx] && promiseMap[metricResultNdx].status) {
				promiseMap[metricResultNdx].status.cancel();
			}
		}

		function getLoadingHtml(label) {
			var html = '<div class="myTooltip">' +
				'<div class="tooltipBody">' +
				'<table border="2px solid white" style="background-color:black;color:white;">' +
				'<tr>' +
				'<th >Updated</th>' +
				'<th >' + label + '</th>' +
				'<th >User</th>' +
				'</tr>' +
				'<tr>' +
				'<td colspan="3">Loading...</td>' +
				'</tr>' +
				'</div>' +
				'</div>';
			return html;
		}

		function getCommentTooltipHtml(data) {
			var name = 'Comment History';
			var html = '<div style="text-align:left; padding:0px;" class="myTooltip">' +
				'<div class="tooltipBody">' +
				'<table border="2px solid white" style="background-color:black;color:white;">' +
				'<tr>' +
				'<th >Updated</th>' +
				'<th >Comment</th>' +
				'<th >User</th>' +
				'</tr>';

			for (var i = 0; i < data.length; i++) {
				var cmt = data[i].comment;
				var extraText = '';
				if (data[i].roleType && data[i].roleType == 'Supplier') {
					extraText = ' (Supplier)';
				}
				html += '<tr>' +
					'<td>' + $filter('date')(data[i].updatedTime, 'mediumDate', 'UTC') + '</td>' +
					'<td>' + cmt + '</td>' +
					'<td>' + data[i].updateUser + extraText + '</td>' +
					'</tr>';
			}
			html += '</table></div></div>';
			return $sce.trustAsHtml(html);
		}

		function getTooltip(metricResultNdx) {
			if (!vm.tooltips[metricResultNdx]) return '';
			return vm.tooltips[metricResultNdx].status;
		}

		function tooltipIsReady(metricResultNdx) {
			return tooltipVisibleMap[metricResultNdx];
		}

		function sortFunction(row) {
			if (
				(vm.sortColumn === 'unformattedValue' || vm.sortColumn === 'unformattedValueA' || vm.sortColumn === 'unformattedValueB')
						 && row.unformattedValue === 'N/A') {
				return vm.reverseSort ?  -Number.MAX_VALUE : Number.MAX_VALUE;
			}
			return row[vm.sortColumn];
		}

		function setSort(column) {
			if (column === vm.sortColumn) {
				vm.reverseSort = !vm.reverseSort;
			} else {
				vm.reverseSort = false;
				vm.sortColumn = column;
			}
			var userAttributeValue = vm.sortColumn + '/' + (vm.reverseSort ? '0': '1');
			userAttributes.setHashed(HASH_PREFIX, vm.row.crossSiteName, userAttributeValue);
		}

		function getRowFromMetricResultNdx(metricResultNdx) {
			for (var i = 0; i < vm.row.metricResults.length; i++) {
				if (vm.row.metricResults[i].metricResultNdx === metricResultNdx) {
					return vm.row.metricResults[i];
				}
			}
			return undefined;
		}

		function resetTableColumnWidths() {
			var availableWidth = jQuery('.smartTableGrid').width();
			var currentColumnWidth = 80;
			var factoryColumn = vm.row.showSite ? 1 : 0;
			var valueStreamColumn = vm.row.showValueStream ? 1 : 0;
			var categoryColumn = vm.row.showCategory ? 1 : 0;
			var valueABColumns = vm.row.showValueAB ? 1 : 0;
			var extraColumns = factoryColumn + valueStreamColumn + categoryColumn + valueABColumns + 1;
			jQuery('.metric-comment-slide-in.metric-values table tbody tr').each(function () {
				var cell = jQuery(this).find('td:eq(1) span');
				var cellWidth = cell.width();
				if (cell.text() !== 'Metric entry is suspended for this time period.' &&
					cellWidth > currentColumnWidth) {
					currentColumnWidth = cellWidth;
				}
			});

			currentColumnWidth = currentColumnWidth + 20;
			var extraColumnWidth = (availableWidth - (80 + currentColumnWidth)) / extraColumns;
			jQuery('.metric-comment-slide-in.metric-values table thead th.category-column').css('width', extraColumnWidth);
			jQuery('.metric-comment-slide-in.metric-values table thead th.site-column').css('width', extraColumnWidth);
			jQuery('.metric-comment-slide-in.metric-values table thead th.value-stream-column').css('width', extraColumnWidth);
			jQuery('.metric-comment-slide-in.metric-values table thead th.comment-column').css('width', extraColumnWidth);
			jQuery('.metric-comment-slide-in.metric-values table thead th.value-column').css('width', currentColumnWidth);
		}

		function setDefaultSort(crossSiteName) {
			var userAttributeValue = userAttributes.getHashed(HASH_PREFIX, crossSiteName);
			var sort_column = DEFAULT_SORT_COLUMN;
			var sort_dir = DEFAULT_SORT_DIR !== 'ASC';
			if (userAttributeValue) {
				var sortValues = userAttributeValue.split('/');
				sort_column = sortValues[0];
				sort_dir = sortValues[1] === '1' ? false: true;
			}

			vm.sortColumn = sort_column;
			vm.reverseSort = sort_dir;
		}
		
		function getMetricInfoSection() {
			if (!vm.metricInfo) {
				metricsService.getMetricsInfo(vm.row.factoryNdxs, vm.row.metricName, vm.row.crossSiteName, vm.row.isCrossSite, vm.row.queryParams).then(function (data) {
					if (data && data.length) {
						if (data[0]['valueStream'] !== 'UndefinedValuestream') {
							vm.showValueStreams = true;
						}
						vm.metricInfo = data;
					} else {
						vm.metricInfo = [];
					}
				});
			}
		}
		
		function selectTab(tabName) {
			vm.activeTab = tabName;
			switch (vm.activeTab) {
			case 'info':
				getMetricInfoSection();
				break;
			};
		}
		
		var modal;
		var getModalInterval = function () {
			modal = document.getElementsByClassName('metric-comment-slide-in')[0];

			if (vm.row.metricResults && vm.row.metricResults.length > 0) {
				modal = jQuery('.metric-comment-slide-in.metric-values table tbody tr').length == vm.row.metricResults.length;
			}
			if (modal) {
				clearInterval(getModal);
				resetTableColumnWidths();
			}
		};
		modal = document.getElementsByClassName('metric-comment-slide-in')[0];
		if (!modal) {
			var getModal = setInterval(getModalInterval, 200);
		} else {
			resetTableColumnWidths();
		}
	}
})();
